// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"closeButton__IONyG","closeButton--light":"closeButton--light__3ebvu"};